<template>
  <div class="sign">
    <div class="sign-container">
      <div class="sign-title">
        <div class="title">找回密码</div>
        <div>
          <el-link type="primary" :underline="false" style="font-size: 12px; vertical-align: baseline;" @click="$router.push({ path: '/login' })">使用已有账号登录</el-link>
        </div>
      </div>
      <el-form :model="signForm" :rules="rules" ref="signForm" class="demo-ruleForm" label-width="100px">
        <el-form-item prop="loginName" label="手机号">
          <el-input v-model.trim="signForm.loginName" placeholder="请输入手机号码" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item prop="code" label="验证码" style="position: relative;">
          <el-input  v-model.trim="signForm.code" placeholder="请输入短信验证码" maxlength="6" ></el-input>
          <div class="box" v-if="disabled"><span style="cursor: pointer;" @click.stop="getCode">{{btnTxt}}</span></div>
          <div class="box" v-if="!disabled"><span style="color: #999;">{{txt}}</span></div>
        </el-form-item>
        <el-form-item prop="password" label="新密码">
          <el-input :type="pwd ?'password': 'text'" autocomplete="new-password" v-model.trim="signForm.password" placeholder="密码格式为8-16位数字大小写字母组合">
            <i
            slot="suffix"
            style="margin-right: 6px;"
            class="cursor" :class="pwd? 'iconfont icon-xianshi': 'iconfont icon-yincang'"
            @click="pwd = !pwd"></i>
          </el-input>
        </el-form-item>
        <el-form-item prop="passwords" label="确认密码">
          <el-input :type="pwds ? 'password': 'text'" autocomplete="new-password" v-model.trim="signForm.passwords" placeholder="确认密码">
            <i
            slot="suffix"
            style="margin-right: 6px;"
            class="cursor" :class="pwds? 'iconfont icon-xianshi': 'iconfont icon-yincang'"
            @click="pwds = !pwds"></i>
          </el-input>
        </el-form-item>
        <el-form-item style="margin-bottom: 10px;">
          <el-button style="width: 100%;"  type="primary" :loading="loading" @click="Submit">提 交</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--  -->
    <el-dialog :close-on-click-modal='false' width="500px" :visible.sync="dialogVisible" :modal-append-to-body='false' center>
      <div >
        <p style="text-align: center;"><i style="color: #67c23a; font-size: 60px;" class="el-icon-success"></i></p>
        <p style="text-align: center; color: #262626; font-weight: 700; margin-top: 20px;">注册申请提交成功，最后结果会以短信的方式发送，请注意查收</p>
      </div>
      <div slot="footer" style="text-align: center;">
        <el-button type="primary" size="small" @click="hanldeBack">完 成</el-button>
      </div>
    </el-dialog>
    <Verificate :isShow="isShow" @success="successVer()" @cancel="cancleVer()"></Verificate>
  </div>
</template>

<script>
import md5 from 'js-md5'
import Verificate from '@/components/verificate/Verificate'
import { RegisterReset, LoginGetPhoneMa } from '@/api/system'
export default {
  name: 'Sign',
  components: { Verificate },
  data () {
    const checkPPwd = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/
        if (!reg.test(value)) {
          callback(new Error('密码格式为8-16位数字大小写字母组合'))
        } else {
          callback()
        }
      }
    }
    const checkPPwds = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.signForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      isShow: false,
      dialogVisible: false,
      checked: false,
      disabled: true,
      btnTxt: '获取验证码',
      txt: '',
      pwd: true,
      pwds: true,
      loading: false,
      signForm: {
        loginName: '',
        code: '',
        password: '',
        passwords: ''
      },
      rules: {
        loginName: [
          { required: true, message: '请输入正确的手机号码', trigger: 'blur' },
          { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号码', trigger: ['blur', 'change'] }
        ],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        password: [{ required: true, validator: checkPPwd, trigger: ['blur', 'change'] }],
        passwords: [{ required: true, validator: checkPPwds, trigger: ['blur', 'change'] }]
      }
    }
  },
  watch: {},
  created() {
  },
  methods: {
    Submit() {
      this.$refs.signForm.validate(valid => {
        if (!valid) return false
        this.loading = true
        const parmas = {
          mobile: this.signForm.loginName,
          password: md5(this.signForm.password),
          valCode: this.signForm.code
        }
        RegisterReset(parmas).then(res => {
          this.loading = false
          if (res.code == '904') {
            this.$message.error(res.msg)
          }
          if (res.code === '000') {
            this.$message.success('操作成功')
            setTimeout(() => { this.$router.push({ path: '/login' }) }, 1000)
          }
        })
      })
    },
    hanldeBack() {
      this.$router.push({ path: '/login' })
    },
    // 获取短信验证码 1、 唤起滑块校验
    getCode () {
      this.$refs.signForm.validateField('loginName', val => {
        if (val) return false
        this.isShow = true
      })
    },
    // 回调 登录
    // 1 active == 0 账号密码登录      2、active == 1 发送短信验证码
    successVer () {
      this.isShow = false
      LoginGetPhoneMa({ mobile: this.signForm.loginName }).then((res) => {
        if (res.code === '000') {
          this.$message.success('验证码发送成功')
          this.time = 60
          this.disabled = false
          this.timer()
        }
      })
    },
    cancleVer () {
      this.isShow = false
    },
    // 计时器
    timer () {
      if (this.time > 0) {
        this.time--
        this.txt = this.time + 's'
        setTimeout(this.timer, 1000)
      } else {
        this.btnTxt = '重新获取'
        this.disabled = true
        this.time = 0
      }
    }
  }
}
</script>

<style lang="less" scoped>
.sign {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #ddd;
  background: url(../assets/images/login.jpg) no-repeat;
  background-size: cover;
  // overflow-y: auto;
  // padding: 50px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  .sign-container {
    margin: 0 auto;
    width: 700px;
    padding: 40px 20px;
    border: 1px solid #ebeef5;
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    border-radius: 4px;
    box-sizing: border-box;
    .sign-title {
      font-weight: 700;
      font-size: 18px;
      line-height: 50px;
      border-bottom: 2px solid coral;
      margin-bottom: 30px;
      display: flex;
      .title {
        flex: 1;
      }
    }
  }
}
.box::before {
  content: '';
  position: absolute;
  width: 1px;
  height: 16px;
  top: 12px;
  left: 0;
  background: #D8D8D8;
}
.box {
  width: 120px;
  position: absolute;
  right: 0;
  top: 0;
  text-align: center;
  font-size: 14px;
  color: #2A73FF;
}
</style>
